import { render, staticRenderFns } from "./ModalArchivoGrande.vue?vue&type=template&id=225e5024"
import script from "./ModalArchivoGrande.vue?vue&type=script&lang=js"
export * from "./ModalArchivoGrande.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports